import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-Tips",
  "use": "icon-Tips-usage",
  "viewBox": "0 0 200 200",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 200 200\" id=\"icon-Tips\">\n<path d=\"M100,12.9C52,12.9,12.9,52,12.9,100S52,187.1,100,187.1s87.1-39.1,87.1-87.1S148,12.9,100,12.9z M106.3,143.8\n\tc0,3.5-2.8,6.3-6.3,6.3s-6.3-2.8-6.3-6.3V87.5c0-3.5,2.8-6.3,6.3-6.3c3.5,0,6.3,2.8,6.3,6.3V143.8z M100,68.8\n\tc-5.2,0-9.4-4.2-9.4-9.4c0-5.2,4.2-9.4,9.4-9.4s9.4,4.2,9.4,9.4C109.4,64.5,105.2,68.8,100,68.8z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol